module.exports = __webpack_public_path__ + "img/toggle_side_bar.39b8d294.svg";